var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuShopbydivit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.02219 20 6.08879 19.4135 4.4443 18.3147C2.79981 17.2159 1.51809 15.6541 0.761209 13.8268C0.00433284 11.9996 -0.193701 9.98891 0.192152 8.0491C0.578004 6.10929 1.53041 4.32746 2.92894 2.92894C4.32746 1.53041 6.10929 0.578004 8.0491 0.192152C9.98891 -0.193701 11.9996 0.00433284 13.8268 0.761209C15.6541 1.51809 17.2159 2.79981 18.3147 4.4443C19.4135 6.08879 20 8.02219 20 10C19.9971 12.6513 18.9426 15.1931 17.0679 17.0679C15.1931 18.9426 12.6513 19.9971 10 20ZM10 2C8.41775 2 6.87104 2.4692 5.55544 3.34825C4.23985 4.2273 3.21447 5.47673 2.60897 6.93854C2.00347 8.40035 1.84504 10.0089 2.15372 11.5607C2.4624 13.1126 3.22433 14.538 4.34315 15.6569C5.46197 16.7757 6.88743 17.5376 8.43928 17.8463C9.99113 18.155 11.5997 17.9965 13.0615 17.391C14.5233 16.7855 15.7727 15.7602 16.6518 14.4446C17.5308 13.129 18 11.5823 18 10C17.9976 7.879 17.154 5.84556 15.6542 4.34578C14.1545 2.84601 12.121 2.00239 10 2Z",
    fill: "#FFCC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12798 14.204L6.74298 12.827V10.851H9.00098V11.671L11.894 9.99602L9.00098 8.32902V9.14902H6.74298V7.17302L9.12798 5.79602L14.028 8.62302V11.377L9.12798 14.204Z",
    fill: "#FFCC33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuShopbydivit);
export default __webpack_public_path__ + "static/media/menu-shopbydivit.457b4503ee459495cc30dad27756cac6.svg";
export { ForwardRef as ReactComponent };